import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import MultSelect from "../../../../Components/CardsPages/Forms/MultSelect";
import UnForm from "../../../../Components/Form";
import StickyToolbar from "../../../../Components/StickyToolbar";
import { ListarEquipesDeVendasController } from "../../../../Controllers/Vendas/EquipeVendas/EquipeVendasControllers";
import {  ListarPontosDeVendaController } from "../../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import { IGestaoDeVisitasBody } from "../../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import StorageManagerCapys from "../../../../Tools/Storage";

interface IGestaoDeVisitasResponseProps {
    handleSubmit: (filter: IGestaoDeVisitasBody) => void;
    defaultFilter?: IGestaoDeVisitasBody;
    storageManager: StorageManagerCapys<IGestaoDeVisitasBody>;
}
export default function FiltroDeVisitas(props: IGestaoDeVisitasResponseProps) {
    const filter = props.defaultFilter;
    const hadleFilterFormSubmit = props.handleSubmit;
    const FormMethods = useForm();
    const { reset } = FormMethods;
    return (
        <>

            <StickyToolbar active={Boolean(filter)}>
                <FormProvider {...FormMethods}>

                    <UnForm handleSubmit={hadleFilterFormSubmit} usingContext>

                        <div className="col-12 mt-3">
                            <label>Data Inicio</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIO"
                                defaultValue={filter?.DT_INICIO} />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FIM"
                                defaultValue={filter?.DT_FIM} />
                        </div>

                        <div className="col-12 mt-3">
                            <label>Equipes Vendas</label>
                            <MultSelect
                                name="ID_EQUIPE_VENDAS"
                                controller={ListarEquipesDeVendasController}
                                getDS={(e) => e.DS_EQUIPE_VENDAS}
                                getKeyValue={(e) => e.ID_EQUIPE_VENDAS}
                                virtual={true}
                                showSearch={false}
                            >
                                <option></option>
                            </MultSelect>
                        </div>

                        <div className="col-12 mt-3">
                            <label>Ponto de Venda</label>
                            <UnForm.LazySelect
                                name="ID_PONTO_VENDA"
                                controller={ListarPontosDeVendaController}
                                getDS={(e) => e.DS_PONTO_VENDA}
                                getKeyValue={(e) => e.ID_PONTO_VENDA}
                               
                            >
                                <option></option>
                            </UnForm.LazySelect>


                        </div>

                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon icon={faFilter} className="mr-2" />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    window.sessionStorage.removeItem(
                                        "FILTRO_GESTAO_VISITAS"
                                    );
                                    reset(props.defaultFilter);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon icon={faTimes} className="mr-2" />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar></>
    )
}